import PropTypes from 'prop-types';
import { Heading, Stack } from '@etg/wings';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { Icon } from '@eti/components';

const buttonWrapperStyles = css`
  display: flex;
  justify-content: center;
`;

const buttonStyles = css`
  align-items: center;
  appearance: none;
  background-color: ${etiColors.white};
  border: 1px solid ${etiColors.info.solid};
  border-radius: 3px;
  color: ${etiColors.info.solid};
  cursor: pointer;
  display: inline-flex;
  font-size: 0.875rem;
  height: 44px;
  justify-content: center;
  width: 100%;

  @media ${mediaQueries.medium.up} {
    border: 0;
    height: auto;
    width: auto;
  }
`;

const buttonIconStyles = css`
  display: none;
  width: 16px;

  @media ${mediaQueries.medium.up} {
    display: block;
    margin-right: 10px;

    [dir='rtl'] & {
      margin-left: 10px;
      margin-right: 0;
    }
  }
`;

const ReviewModalSection = ({ button, children, dataTestId, subtitle, title }) => (
  <div data-testid={dataTestId}>
    <Stack>
      <Stack spacing={4}>
        {title && <Heading level={3}>{title}</Heading>}
        {subtitle && <span>{subtitle}</span>}
      </Stack>
      {children}
      {button && (
        <div className={buttonWrapperStyles}>
          <button
            className={buttonStyles}
            data-testid={button.testId}
            onClick={button.onClick}
            type="button"
          >
            <Icon className={buttonIconStyles} color={etiColors.info.solid} id="edit-square" />
            {button.text}
          </button>
        </div>
      )}
    </Stack>
  </div>
);

ReviewModalSection.propTypes = {
  button: PropTypes.shape({
    onClick: PropTypes.func,
    testId: PropTypes.string,
    text: PropTypes.string,
  }),
  children: PropTypes.node,
  dataTestId: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default ReviewModalSection;
